import { init, CoreParams, ClientParams } from './init';
import { markPerformance } from './performance/index';
import { ErrorReporter } from './errorReporter.type';

declare global {
  interface Window {
    mmClientApi?: Array<any> | { push: (eventName: string, params: any) => void };
  }
}

export const initCore = (params: CoreParams, errorReporter: ErrorReporter) => {
  window.mmClientApi = window.mmClientApi || [];
  window.mmClientApi.push('getPageData', (pageDataObject: ClientParams) => {
    markPerformance('core-start');
    init({
      ...params,
      platform: pageDataObject.platform,
      trafficSource: pageDataObject.trafficSource,
      trafficSourceAndId: pageDataObject.trafficSourceAndId,
      trafficId: pageDataObject.trafficId,
      mmUserIdentifier: pageDataObject.mmUserIdentifier,
    }, errorReporter);
  });
};

export * from './init';
